import React from 'react';

import Metrics from '@spotahome/soyuz-metrics';

import cityToggleConfig from '@common/config/cityToggleConfig';

import BookSecurelyBannerBack from './components/BookSecurelyBannerBack';
import BookSecurelyBannerFront from './components/BookSecurelyBannerFront';
import SelectBannerBack from './components/SelectBannerBack';
import SelectBannerFront from './components/SelectBannerFront';

/*
  Position of the banner.
  0 count as a position.
  This allows to include multiple banners to the HomeCardList component
*/
export const bannerList = cityId => ({
  3: cityToggleConfig(cityId).showSelectInfoCard
    ? {
        name: 'select',
        isActive: true
      }
    : {
        name: 'book-securely',
        isActive: true
      }
});

export const getNumberActiveBanners = cityId => {
  return Object.keys(bannerList).filter(
    bannerPosition => bannerList(cityId)[bannerPosition].isActive
  ).length;
};

const bannerConfig = {
  select: {
    Front: SelectBannerFront,
    Back: SelectBannerBack,
    tracking: {
      eventCategory: 'Search',
      eventAction: 'informative-homecard',
      eventLabel: 'select'
    },
    className: 'select'
  },
  'book-securely': {
    Front: BookSecurelyBannerFront,
    Back: BookSecurelyBannerBack,
    tracking: {
      eventCategory: 'Search',
      eventAction: 'informative-homecard',
      eventLabel: '24h-return'
    },
    className: 'default'
  }
};

const defaultBannerConfig = {
  Front: null,
  Back: null,
  tracking: null
};

const decoratedConfig = ({ Front, Back, tracking, className }) => ({
  renderFront: props => <Front {...props} />,
  renderBack: props => <Back {...props} />,
  track: () => tracking && Metrics.ga.sendEvent(...Object.values(tracking)),
  className
});

export const getBannerConfig = name => {
  return decoratedConfig(bannerConfig[name] || defaultBannerConfig);
};

export default {
  getBannerConfig,
  bannerList,
  getNumberActiveBanners
};
